import { render, staticRenderFns } from "./CreatorsSliderItem.vue?vue&type=template&id=242cb1af&scoped=true&"
import script from "./CreatorsSliderItem.vue?vue&type=script&lang=ts&"
export * from "./CreatorsSliderItem.vue?vue&type=script&lang=ts&"
import style0 from "./CreatorsSliderItem.vue?vue&type=style&index=0&id=242cb1af&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242cb1af",
  null
  
)

export default component.exports